import React from 'react';
import PageHeader from 'components/PageHeader/PageHeader';
import { Icon, IconList, Link } from 'components/core';

type Props = {
  backLink: string;
};

const SupportLink = () => (
  <Link variant="brand" to="https://support.covidence.org/help/export-prisma">
    <Icon aria-label="Help" icon={IconList.solid.faQuestionCircle} />
    Exporting and interpreting PRISMA
  </Link>
);

const PrismaPageHeader = ({ backLink }: Props) => {
  return (
    <PageHeader
      headerText="PRISMA"
      backLink={backLink}
      rightContent={SupportLink}
    />
  );
};

export default PrismaPageHeader;
